
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/services",
      function () {
        return require("private-next-pages/[locale]/services.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/services"])
      });
    }
  